(function () {
    'use strict';

    var module = angular.module('app');

    module.directive('userInfo', [
        function () {
            return {
                restrict: 'E',
                scope: {},
                templateUrl: '/app/features/header/userInfo/userInfo.tpl.html',
                controller: 'userInfoCtrl',
                controllerAs: 'vm',
                bindToController: true
            };
        }
    ]);

    module.controller('userInfoCtrl', [
        'currentUserService', 'authService',
        function (currentUserService, authService) {
            var vm = this;
            vm.currentUser = currentUserService.getCurrentUser();
            vm.logout = function () {
                authService.logout();
            }
            vm.isInRole = currentUserService.isInRole;
        }
    ]);
}());